import { findTotaTestlTimeListByProjectId } from "@/api/device/device";
import SideTool from "@/global/components/side-tool";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router";
import "./test-record-panel.less"
import classNames from "classnames";
import { CommonTabbarContext } from "@/App";
import { TAB_TYPE } from "@/enums/tab-type";
import { node } from "prop-types";
import { CommonTabbarState } from "@/global/components/common-tabbar";
import { getShortDateName } from "@/global/utils/date-utils";

export default function TestRecordSide() {

    const { projectId } = useParams()

    const [dateList, setDateList] = useState<number[]>()

    const [activeDate, setActiveDate] = useState<number>()

    const commonTabbarContext = useContext<CommonTabbarState>(CommonTabbarContext); // tab上下文

    useEffect(() => {
        findTotaTestlTimeListByProjectId(Number(projectId)).then(res => {
            setDateList(res?.data || [])
        })
    }, [])

    // 跳转至设备详情
    const showTestDetail = (date: number) => {
        if (!date) return;
        setActiveDate(date)
        commonTabbarContext.navigate(`${TAB_TYPE.TEST_RECORD}/${date.toString()}`)
    }

    return (
        <div className="test-record-main">
            <SideTool />
            <div className="test-list">
                {dateList?.map((item, index) => (
                    <div key={index} className={classNames({
                        "list-item": true,
                        "list-item-active": activeDate == item
                    })}
                        onClick={() => { showTestDetail(item) }}
                    >
                        {getShortDateName(item) + " 测试记录"}
                    </div>
                ))}

            </div>
        </div>
    )
}